import type {ReactElement} from 'react';
import React from 'react';
import styles from './cropper-panel-options.module.scss';
import {RemoveBackgroundIconBox} from '../remove-background-icon-box';

interface CropperModalOptionsProps {
  showRemoveBackgroundOption: boolean;
  imgSrc: string;
  imgHashedFilename?: string;
  isSmallScreen: boolean;
  className?: string;

  children: ReactElement;
}

export function CropperPanelOptions({className = '', ...props}: CropperModalOptionsProps): ReactElement {
  return (
    <div className={`${styles.cropperOptionsContainer} ${props.isSmallScreen ? styles.small : ''}`}>
      <ul className={`buttons blocks icons ${className} ${styles.croppingPresetList}`}>
        {props.children}
        {props.showRemoveBackgroundOption && props.imgSrc && props.imgHashedFilename ? (
          <li className={styles.removeBackgroundContainer}>
            <RemoveBackgroundIconBox imgHashedFilename={props.imgHashedFilename} className={styles.removeBackgroundIconBox} />
          </li>
        ) : null}
      </ul>
    </div>
  );
}
